import React from "react";
import BasedModal from "components/BaseModalComponents/BasedModal";
import ModalHeader from "components/BaseModalComponents/Header/ModalHeader";
import ModalFooter from "components/BaseModalComponents/Footer/ModalFooter";
import {
    Container,
    ModalBody,
    Row,
} from "components/FilterModal/filterModalStyles"; // или свои стили
import { Button } from "antd";

export interface ApplyFile {
    id: number | string;
    name: string;
}

interface ApplyConfigModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    applyFiles: ApplyFile[];
    selectedConfigIds: (number | string)[];
    onChangeSelected: (ids: (number | string)[]) => void;
    onConfirm: () => void;
    title?: string;
}

const ApplyConfigModal: React.FC<ApplyConfigModalProps> = ({
    isOpen,
    onRequestClose,
    applyFiles,
    selectedConfigIds,
    onChangeSelected,
    onConfirm,
    title = "Выберите конфиги для применения",
}) => {

    const toggleConfig = (id: number | string) => {
        const isSelected = selectedConfigIds.includes(id);

        if (isSelected) {
            onChangeSelected(selectedConfigIds.filter((item) => item !== id));
        } else {
            onChangeSelected([...selectedConfigIds, id]);
        }
    };

    const selectAll = () => {
        onChangeSelected(applyFiles.map((file) => file.id));
    };

    const clearAll = () => {
        onChangeSelected([]);
    };

    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <Container style={{ width: 420,padding:"20px 40px 0", gap:"8px",minHeight: 500 }}>
                <ModalHeader >
                    <div>{title}</div>
                </ModalHeader>
<div>Выберите конфиги для применения</div>
                <ModalBody>
                    {applyFiles?.length > 0 && (
                        <div
                            style={{
                                display: "flex",
                                gap: 12,
                                marginBottom: 12,
                            }}
                        >
                            <Button  onClick={selectAll}>
                                Выбрать все
                            </Button>
                            <Button  onClick={clearAll}>
                                Снять все
                            </Button>
                        </div>
                    )}

                    {applyFiles?.length ? (
                        applyFiles.map((file) => {
                            const checked = selectedConfigIds.includes(file.id);

                            return (
                                <Row key={file.id}>
                                    <label
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            cursor: "pointer",
                                            width: "100%",
                                            padding: "6px 0",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={checked}
                                            onChange={() => toggleConfig(file.id)}
                                        />
                                        <span>{file.name}</span>
                                    </label>
                                </Row>
                            );
                        })
                    ) : (
                        <p style={{ padding: "12px 0" }}>Нет доступных файлов</p>
                    )}
                </ModalBody>

                <ModalFooter
                    applyText="Применить"
                    cancelText="Отменить"
                    onApplyClick={onConfirm}
                    onCancelClick={onRequestClose}
                    disabled_apply_button={selectedConfigIds.length === 0}
                />
            </Container>
        </BasedModal>
    );
};

export default ApplyConfigModal;